import { servicesLinks } from './routes';
import { productLinks } from './routes';
import { followUsIconLinks } from './routes';

export { servicesLinks, productLinks, followUsIconLinks };
